// src/api/apiHelper.js
import axios from 'axios';
import loadingService from '../services/loadingService';

// TO ZOSTAŁO (Kluczowe dla CSRF/Cookies)
axios.defaults.withCredentials = true;

const apiUrl = process.env.REACT_APP_API_SOURCE;

const api = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor dla ZAPYTAŃ (request)
api.interceptors.request.use(
  (config) => {
    // --- JEDYNA ZMIANA: Obsługa flagi ---
    // Jeśli w wywołaniu api.post(..., { skipLoading: true }) nie ma tej flagi,
    // to spinner działa po staremu (pokazuje się).
    if (!config.skipLoading) {
        loadingService.show();
    }
    // ------------------------------------

    const token = localStorage.getItem('token');
    
    if (token) {
      config.headers['Authorization'] = `Token ${token}`;
    }
    
    return config;
  },
  (error) => {
    loadingService.hide();
    return Promise.reject(error);
  }
);

// Interceptor dla ODPOWIEDZI (response)
api.interceptors.response.use(
  (response) => {
    // Request ze skipLoading nie zwiększał licznika, więc nie może go zmniejszać —
    // inaczej cichy request z tła zdejmował spinner innego, wciąż trwającego.
    if (!response.config?.skipLoading) loadingService.hide();
    return response;
  },
  (error) => {
    if (!error.config?.skipLoading) loadingService.hide();

    // Twoja oryginalna logika wylogowania
    if (error.response && error.response.status === 401) {
      console.error("apiHelper: Błąd 401 - Wylogowywanie");
      localStorage.removeItem('token');
      localStorage.removeItem('user_preferences');
      
      if (window.location.pathname !== '/login') {
         window.location.href = '/login'; 
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;